class TabComponent extends HTMLElement {
    constructor() {
        super()
        this.onTabClick = this.onTabClick.bind(this)
        this.buttons = this.querySelectorAll("button[data-tab]")
    }

    connectedCallback() {
        this.setupTabs()
    }

    setupTabs() {
        this.buttons.forEach((button) => {
            button.addEventListener("click", this.onTabClick)
        })

        this.activateTab(this.buttons[0])
    }

    onTabClick(event) {
        this.activateTab(event.target)
    }

    activateTab(tabButton) {
        this.buttons.forEach((button) => {
            button.classList.remove("active")
        })

        // Hide all tab panels
        this.querySelectorAll(".tab-content").forEach((panel) => {
            panel.classList.remove("active")
            this.dataset.activeTab = "1"
        })

        // Activate the clicked tab and show the associated panel
        tabButton.classList.add("active")

        const panels = this.querySelectorAll(
            `.tab-content[data-tab="${tabButton.dataset.tab}"]`
        )

        if (panels) {
            panels.forEach((panel) => {
                panel.classList.add("active")
                this.dataset.activeTab = tabButton.dataset.tab
            })
        }

        this.buttons.forEach((button) => {
            if (button.dataset.tab == this.dataset.activeTab) {
                button.classList.add("active")
                button.setAttribute("aria-selected", "true")
            }
        })
    }
}

customElements.define("tab-component", TabComponent)
